export default {
  ages (state) {
    return {
      ...state,
      storeName: 'ages'
    }
  }
}
